import { createSlice } from '@reduxjs/toolkit';

const filtersSlice = createSlice({
  name: 'filters',
  initialState: {
    selectedFilters: {}
  },
  reducers: {
    setSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    }
  }
});

export const { setSelectedFilters } = filtersSlice.actions;
export default filtersSlice.reducer;
